<template>
    <div class="title-row">
        <div class="left">
            <img :src="TitleIcon" class="title-icon" :style="{visibility: showIcon ? 'visible' : 'hidden'}">
            <div class="title-text">
                <div class="text1" v-if="titleText" v-html="titleTextHtml"></div>
                <div class="text2" v-if="subtitleText">{{ subtitleText }}</div>
            </div>
        </div>
        <slot v-show="showIcon" class="message-icon" name="comment"></slot>
    </div>
</template>
<script>
import TitleIcon from '@/assets/img/ITA-question.png'

export default {
    name: 'TitleRow',
    props: {
        titleText: {
            type: String,
            default: ''
        },
        subtitleText: {
            type: String,
            default: ''
        },
        showMessage: {
            type: Boolean,
            default: true
        },
        showIcon: {
            type: Boolean,
            default: true
        }
    },
    data() {return {
        TitleIcon
    }},
    computed: {
        titleTextHtml() {
            return this.titleText.replaceAll("\n", '<br/>')
        }
    }
}
</script>
<style scoped>
.title-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.title-row .left {
    display: flex;
    flex-direction: row;
}
.title-row .left .title-icon {
    width: 40px;
    height: 40px;
}
.title-row .left .title-text {
    margin-left: 10px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;
}
.title-row .left .title-text .text1 {
    font-size: 16PX;
    font-weight: 600;
}
.title-row .left .title-text .text2 {
    font-size: 13PX;
    color: #4682ec;
    margin-top: 20px;
}
.title-row .message-icon {
    font-size: 22px;
    /* color: #ccced2; */
    cursor: pointer;
}
</style>